import { makeStyles } from 'tss-react/mui';

const name = 'CHainsListPageTitle';

export const useChainsListPageTitleStyles = makeStyles({ name })(theme => ({
  root: {
    marginBottom: theme.spacing(8),

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(7),
    },
  },
}));
